const numberFormat = new Intl.NumberFormat('en-US');
const dateFormat = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

export const formatNumber = (value: number | null | undefined) =>
  value === null || value === undefined || isNaN(value) ? '–' : numberFormat.format(value);

const toDate = (value: string | number | Date | null | undefined) => {
  if (value === null || value === undefined || value === '') return null;
  const date = value instanceof Date ? value : new Date(value);
  return isNaN(date.valueOf()) ? null : date;
};

export const formatDate = (value: string | number | Date | null | undefined) => {
  const date = toDate(value);
  return date ? dateFormat.format(date) : '–';
};

export const formatDateTime = (value: string | number | Date | null | undefined) => {
  const date = toDate(value);
  return date ? dateTimeFormat.format(date) : '–';
};

export const timeAgo = (value: string | number | Date | null | undefined) => {
  const date = toDate(value);
  if (!date) return '–';
  const seconds = Math.round((Date.now() - date.valueOf()) / 1000);
  if (seconds < 60) return 'just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} h ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days} d ago`;
  return formatDate(date);
};

export const initialsOf = (name?: string | null, fallback?: string | null) => {
  const source = (name && name.trim()) || (fallback && fallback.trim()) || '?';
  const parts = source.split(/[\s@._-]+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

export const gradeLabel = (grade: number | string | null | undefined) => {
  if (grade === null || grade === undefined || grade === '') return '–';
  if (typeof grade === 'string') return grade;
  if (grade === -1) return 'Pre-K';
  if (grade === 0) return 'K';
  return `Grade ${grade}`;
};

/** "Oct 30, 2026, 2:05 PM (3 h ago)", dropping the relative part once it is just a date again. */
export const withAgo = (value: string | number | Date | null | undefined) => {
  const ago = timeAgo(value);
  const full = formatDateTime(value);
  return ago === formatDate(value) ? full : `${full} (${ago})`;
};

/** Reading time: "<1 min", "12 min", "1 h 05 min", "2 h", "140 h". */
export const formatMinutes = (value: number | null | undefined) => {
  if (value === null || value === undefined || isNaN(value)) return '–';
  if (value <= 0) return '0 min';
  if (value < 1) return '<1 min';
  const total = Math.round(value);
  if (total < 60) return `${total} min`;
  const hours = Math.floor(total / 60);
  const minutes = total % 60;
  if (hours >= 100 || minutes === 0) return `${numberFormat.format(hours)} h`;
  return `${hours} h ${String(minutes).padStart(2, '0')} min`;
};
